module.exports = __webpack_public_path__ + "media/images/upload-file-ea6e76843cec81fabd72238bf90864be.svg";